import VueRouter from 'vue-router';
import routes from "./routes";

export function createRouter({ base, mode }) {
    return new VueRouter({
        routes,
        base,
        mode,
        scrollBehavior(to, from) {
            if(to.name?.match(/^register-/)) {
                return null; // handle in SessionRegister.vue
            }
            if(to.name !== from?.name && to.matched.length === 1) {
                return { x: 0, y: 100 }
            }
        },
    });
}
